module.exports = __webpack_public_path__ + "img/input-error.77129645.svg";